import { useFormatter, useTranslations } from "use-intl";
import { FormatValue } from "./types";

export function useDateFormatterOrNotSpecified() {
  const t = useTranslations("Common");
  const f = useDateFormatter();

  return (value: string | null | undefined) => {
    if (!value) {
      return t("Not specified");
    }
    return f(new Date(value));
  };
}

export function useDateFormatter() {
  const format = useFormatter();

  return (date: FormatValue) => {
    if (!date) {
      return "";
    }

    if (typeof date === "string") {
      date = new Date(date);
    }

    return format.dateTime(date, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
}
